import ContactLink from '@atoms/ContactLink/ContactLink';
import { BG_CREME } from '@constants';
import PagepartBase from '@molecules/PagepartBase/PagepartBase';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './JobAlert.module.scss';
import JobAlertForm from './JobAlertForm';

function JobAlert({ page }) {
  return (
    <PagepartBase backgroundColor={BG_CREME} noPadding>
      <div className={classNames(styles.container, 'u-container-grid')}>
        <div className={styles.card}>
          <JobAlertForm page={page} />
        </div>

        <div className={classNames(styles.card, styles.contact)}>
          <div className={styles.contactContainer}>
            <h3 className={styles.contactTitle}>Heb je een vraag?</h3>
            <p className={styles.paragraph}>
              Bekijk de veelgestelde vragen of neem contact op met één van onze
              recruiters.
            </p>
          </div>

          <div className={styles.links}>
            <ContactLink
              link={{ phone: '0610473613', title: '06 - 10 47 36 13' }}
            />
            <ContactLink
              link={{
                phone: '0610473613',
                title: '06 - 10 47 36 13',
                isWhatsapp: true,
              }}
            />
            <ContactLink
              link={{
                email: 'werken@vitalisgroep.nl',
                title: 'werken@vitalisgroep.nl',
              }}
            />
          </div>
        </div>
      </div>
    </PagepartBase>
  );
}

JobAlert.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    introText: PropTypes.string,
    flashMessage: PropTypes.string,
  }).isRequired,
};

export default JobAlert;
